import React from "react";
import ArrowSVG from "./../icons/LongArrowRight";

const Card = ({ article, reversed }) => {
  const { title, summary, link, image } = article

  return (
    <div className="homepage-blog-article-animation-container">
      <a className={`homepage-blog-article ${reversed ? "homepage-blog-article_reversed" : "" }`} href={link} >
        <div className="homepage-blog-article__content">
          <h3 className="homepage-blog-article__header">{title}</h3>
          <p className="homepage-blog-article__description">{summary}</p>
          <div className="arrowed-link arrowed-link_blue homepage-blog-article__arrowed-link">
            <span className="arrowed-link__text">Читать</span>
            <span className="arrowed-link__arrow">
              <ArrowSVG />
            </span>
          </div>
        </div>
        <div className="homepage-blog-article__image">
          <img  alt={title} title={title} src={image} />
        </div>
      </a>
    </div>
  )
}

export default Card;
